import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { VersionSchema } from "@/types";
import { versionToString } from "@/util";
import { deltaApiStore, deltaStore } from "@/hooks";
import { TextButton, ListItem, Typography } from "@/components/common";


/**
 * A button for opening delta view options.
 */
const __default__ = {
  name: "DeltaModeButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const deltaVersion = computed({
  get() {
    return deltaStore.afterVersion;
  },
  set(newVersion) {
    deltaApiStore.handleCreate(newVersion);
  },
});

/**
 * Returns a version's name.
 * @param version - The version to name.
 * @return The version's name.
 */
function getVersionName(version: VersionSchema): string {
  return versionToString(version);
}

return (_ctx: any,_cache: any) => {
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_unref(TextButton), {
    loading: _unref(deltaApiStore).loading,
    label: "Delta",
    "data-cy": "button-nav-delta",
    icon: "view-delta",
    disabled: _unref(deltaApiStore).deltaVersions.length === 0,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, {
    default: _withCtx(() => [
      (!deltaVersion.value)
        ? (_openBlock(), _createBlock(_component_q_menu, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(Typography), {
                variant: "caption",
                x: "2",
                y: "1",
                value: "Compare Against"
              }),
              _createVNode(_component_q_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deltaApiStore).deltaVersions, (version) => {
                    return _withDirectives((_openBlock(), _createBlock(_unref(ListItem), {
                      key: version.versionId,
                      clickable: "",
                      title: getVersionName(version),
                      onClick: ($event: any) => (deltaVersion.value = version)
                    }, null, 8, ["title", "onClick"])), [
                      [_directive_close_popup]
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "disabled"]))
}
}

})